module.exports = __webpack_public_path__ + "static/media/banner-home-1.01cd01dc.jpg";